function AddWeeksModal({
  isOpen,
  onClose,
  isMobile,
  hoveredButton,
  setHoveredButton,
  handleAddWeeks,
  modalOverlayStyle,
  modalContentStyle,
  closeButtonStyle,
  secondaryButtonStyle,
  appTheme
}) {
  if (!isOpen) return null;

  return (
    <div
      style={modalOverlayStyle}
      onClick={onClose}
    >
      <div
        style={{
          ...modalContentStyle,
          maxWidth: isMobile ? "92vw" : "460px",
          padding: isMobile ? "20px 16px 18px" : "24px 22px 20px"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "12px",
            marginBottom: "14px"
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: isMobile ? "22px" : "26px",
                fontWeight: "700",
                color: appTheme.primaryText,
                lineHeight: 1.1,
                fontFamily: appTheme.fontHeading
              }}
            >
              Add More Weeks
            </h2>

            <div
              style={{
                marginTop: "6px",
                fontSize: "14px",
                color: appTheme.secondaryText,
                lineHeight: 1.5
              }}
            >
              Extend your plan so you can organise meals further ahead.
            </div>
          </div>

          <button
            onMouseEnter={() => setHoveredButton("close-add-weeks")}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={onClose}
            style={closeButtonStyle(hoveredButton, "close-add-weeks", appTheme)}
          >
            ×
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gap: "10px",
            marginTop: "8px"
          }}
        >
          {[1, 2, 4].map((count) => (
            <button
              key={count}
              onMouseEnter={() => setHoveredButton(`add-weeks-${count}`)}
              onMouseLeave={() => setHoveredButton(null)}
              onClick={() => handleAddWeeks(count)}
              style={{
                width: "100%",
                minHeight: "56px",
                padding: "14px 16px",
                borderRadius: "18px",
                border: appTheme.accentBorder,
                background:
                  hoveredButton === `add-weeks-${count}`
                    ? appTheme.accentLight
                    : appTheme.cardBackground,
                color: appTheme.primaryText,
                cursor: "pointer",
                textAlign: "left",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                transition: "all 0.18s ease",
                transform:
                  hoveredButton === `add-weeks-${count}`
                    ? "translateY(-1px)"
                    : "translateY(0)"
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  marginBottom: "4px"
                }}
              >
                +{count} {count === 1 ? "Week" : "Weeks"}
              </div>

              <div
                style={{
                  fontSize: "13px",
                  color: appTheme.secondaryText,
                  lineHeight: 1.4
                }}
              >
                {count === 1 && "Perfect for planning just a little further ahead."}
                {count === 2 && "A good option for a fuller two-to-three week plan."}
                {count === 4 && "Best if you want a proper longer meal-planning stretch."}
              </div>
            </button>
          ))}
        </div>

        <div
          style={{
            marginTop: "14px",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          <button
            onMouseEnter={() => setHoveredButton("cancel-add-weeks")}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={onClose}
            style={secondaryButtonStyle(appTheme, hoveredButton, "cancel-add-weeks")}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddWeeksModal;